import React, { useState, useEffect } from "react";
import {
  Card,
  Col,
  Container,
  Form,
  Row,
  Image,
  Button,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import Swal from "sweetalert2";
import { formatDate } from "../../userpanel/propertydetail";
import DataTable from "react-data-table-component";
import LoaderHome from "../../../components/loader/homeloader";
import {
  acceptRejectBookingHost,
  hostBookings,
} from "../../../utility/apiServices/userServices";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { IMAGES } from "../../../assets/images/images";
import { dashboardChat, dashboardChatView, dashboardStats } from "../../../utility/apiServices/propertiesServices";
import { useTranslation } from "react-i18next";
import { description } from "../../../utility/local/functions/crypto";

const gradientColors = ["#1B91BF ", "#fff"];
const formatYAxisTick = (value) => `${value}`;
const formatYAxisTick2 = (value) => `${value}`;
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="dashboardgraph_tooltip">
        <p className="label">{` ${payload[0].value} Bookings`}</p>
      </div>
    );
  }

  return null;
};
const CustomTooltip2 = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="dashboardgraph_tooltip">
        <p className="label">{`${payload[0].value} Views `}</p>
      </div>
    );
  }

  return null;
};

const PropertydashboardScreen = () => {
  const [searchText, setSearchText] = useState("");
  const [propertyData, setpropertyData] = useState([]);
  const [isDataLoading, setisDataLoading] = useState(true);
  const [saveResult, setSaveResult] = useState(null)
  const [bookingChat, setBookingChatData] = useState(null)
  const [bookingChatVeiw, setBookingChatView] = useState(null)
  const [selectedOption, setSelectedOption] = useState("2");
  const [selected, setSelected] = useState("2");
  const { t, i18n } = useTranslation();
  const [selectionRange, setSelectionRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });
  const currentLanguage = i18n.language;

  const getDashboardStats = async () => {
    try {
      const result = await dashboardStats()
      setSaveResult(result.data)
    } catch (error) {
      console.log('gettig  stats error', error)
    }
  }


  const getDashboardChart = async (option) => {
    try {
      const result = await dashboardChat(option)
      setBookingChatData(result.data.booking)
    } catch (error) {
      console.log('gettig  stats error', error)
    }
  }
  const getDashboardChartView = async (option) => {
    try {
      const result = await dashboardChatView(option)
      console.log(result.data.booking, 'get views ==')
      setBookingChatView(result.data.booking)
    } catch (error) {
      console.log('gettig  stats error', error)
    }
  }

  useEffect(() => {
    getDashboardChartView(selectedOption)
    getDashboardChart(selected)
  }, [])

  const bookings = async (page = 1) => {
    const response = await hostBookings({
      startDate: selectionRange?.startDate
        ? format(selectionRange.startDate, "yyyy-MM-dd")
        : "",
      endDate: selectionRange.endDate
        ? format(selectionRange.endDate, "yyyy-MM-dd")
        : "",
      limit: 20
    }, page);
    if (response?.status) {
      setpropertyData(response?.bookings);
    } else {
      Swal.fire({
        icon: "error",
        text: response?.message,
      });
    }
    setisDataLoading(false);
  };

  const paginationOptions = {
    rowsPerPageText: t("rowsPerPage"),
    rangeSeparatorText: t("of"),
  };


  const handleOptionChange = (event) => {
    const newOption = event.target.value;
    setSelectedOption(newOption);
    getDashboardChartView(newOption);
  };

  const handleOptionChangeBooking = (event) => {
    const newOption = event.target.value;
    setSelected(newOption);
    getDashboardChart(newOption);
  };


  useEffect(() => {
    getDashboardStats()
    setisDataLoading(true);
    bookings();
  }, []);


  const acceptRejectBooking = async (
    propertyId,
    bookingId,
    status,
    modelstatus
  ) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${modelstatus} this booking?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `${modelstatus} Booking`,
      cancelButtonText: "Go back",
      preConfirm: async () => {
        try {
          Swal.showLoading();
          const response = await acceptRejectBookingHost({
            bookingId,
            status,
            propertyId,
          });
          return response;
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: `There was an error. Please try again.`,
            icon: "error",
            confirmButtonText: "OK",
          });
          throw error;
        }
      },
    }).then((result) => {
      console.log(" result:", result);
      if (result.isConfirmed && result.value.status) {
        Swal.fire({
          title: `Booking ${status}`,
          text: t('bookingCancelledSuccess'),
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          updateBookingStatus(bookingId, status);
        });
      } else if (result.isConfirmed) {
        Swal.fire({
          title: "Error",
          text: t('errorCancellingBooking'),
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    });
  };


  const updateBookingStatus = (bookingId, newStatus) => {
    setpropertyData((prevData) =>
      prevData.map((booking) =>
        booking.id === bookingId ? { ...booking, status: newStatus } : booking
      )
    );
  };



  const columns1 = [
    {
      name: "Sno",
      minWidth: "420px",
      selector: (row) => row.image,
      sortable: true,
      cell: (row) => (
        <Link
          to="/property-detail"
          state={{ data: row?.Property }}
          className="d-flex align-items-center tb_content text-decoration-none text-dark"
          style={{ width: '100%', cursor: 'pointer' }}
        >
          <span className="propertytable_icon">
            <Image alt="" src={(() => {
              // Debug Log
              console.log(`[Dashboard Debug] Property ID: ${row?.Property?.id}, Images:`, row?.Property?.images);

              // Safely extract the first image from the first available room
              const images = row?.Property?.images;
              if (Array.isArray(images) && images.length > 0) {
                const firstImageEntry = images[0];
                if (typeof firstImageEntry === 'object' && firstImageEntry !== null) {
                  // Get the first key (room name) and first image in that room
                  const firstRoomImages = Object.values(firstImageEntry)[0];
                  return firstRoomImages?.[0]?.location || "";
                }
                if (typeof firstImageEntry === 'string') return firstImageEntry;
              }
              return "";
            })()} style={currentLanguage === 'he' ? { marginLeft: "1.3rem" } : { marginRight: '1.3rem' }} />
          </span>
          <div className="flex-grow-1">
            <h5>
              {/* {`${row?.Property?.short_description?.length > 30
                ? row?.Property?.short_description?.slice(0, 30) + "..."
                : row?.Property?.short_description
                }`} */}
              {description(row?.Property?.short_description, row?.Property?.short_description_hebrew, i18n.language)}
            </h5>
            <p>
              <Icon icon="system-uicons:location" />
              {row?.Property?.street_address?.length > 30
                ? row?.Property?.street_address.slice(0, 30) + "..."
                : row?.Property?.street_address}
            </p>
            <p className="pColor">
              {/* <Icon icon="flat-color-icons:phone" color="#5c6368" /> */}
              {row?.Property?.phone_number}
            </p>
            <h6>${row?.total_price}</h6>
          </div>
        </Link>
      ),
    },
    {
      name: t("dashboard.booking_date"),
      selector: (row) => row?.start_date,
      minWidth: "200px",
      sortable: true,
      cell: (row) => {
        const isRTL = false;
        return (
          <p style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
            {isRTL ? (
              <>
                <span>{formatDate(row?.end_date)}</span> - <span>{formatDate(row?.start_date)}</span>
              </>
            ) : (
              <>
                <span>{formatDate(row?.start_date)}</span> - <span>{formatDate(row?.end_date)}</span>
              </>
            )}
          </p>
        );
      },
    },
    {
      name: t("dashboard.booked_on"),
      selector: (row) => row.createdAt,
      sortable: true,
      cell: (row) => <p>{formatDate(row?.createdAt)}</p>,
    },
    {
      name: t("dashboard.status"),
      selector: (row) => row?.status,
      sortable: true,
      cell: (row) => (
        <div className="d-flex flex-column align-items-center">
          {row?.status == "pending" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#cce5ff", color: "#004085" }}
              >
                {t("dashboard.pending")}
              </div>
            </div>
          ) : row?.status == "accepted" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#d4edda", color: "#155724" }}
              >
                {t("dashboard.confirmed")}

              </div>
            </div>
          ) : row?.status == "accepted" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#d4edda", color: "#155724" }}
              >
                {t("dashboard.confirmed")}
              </div>
            </div>
          ) : row?.status == "cancelled" ? (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("dashboard.cancelled")}
              </div>
            </div>
          ) : (
            <div className="">
              <div
                className="p-3 rounded"
                style={{ backgroundColor: "#f8d7da", color: "#721c24" }}
              >
                {t("dashboard.rejected")}
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      name: t("dashboard.actions"),
      width: "220px",
      cell: (row) => (
        <div>
          {row?.status == "pending" ? (
            <>
              <div className="">
                <Button
                  className="px-4 "
                  style={{ height: 40, minWidth: 130 }}
                  variant="primary"
                  onClick={() => {
                    acceptRejectBooking(
                      row?.property_id,
                      row?.id,
                      "accepted",
                      "Accept"
                    );
                  }}
                >
                  {t("dashboard.accept")}
                </Button>

                <Button
                  className="px-4 mt-3"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                  onClick={() => {
                    acceptRejectBooking(
                      row?.property_id,
                      row?.id,
                      "rejected",
                      "Reject"
                    );
                  }}
                >
                  {t("dashboard.rejected")}
                </Button>
              </div>
            </>
          ) : row?.status == "cancelled" ? (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                >
                  {t("dashboard.cancelled")}
                </Button>
              </div>
            </>
          ) : row?.status == "accepted" ? (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="success"
                >
                  {t("dashboard.accepted")}
                </Button>
              </div>
            </>
          ) : (
            <>
              <div className="">
                <Button
                  disabled
                  className="px-4"
                  style={{ height: 40, minWidth: 130 }}
                  variant="danger"
                >
                  {t("dashboard.rejected")}
                </Button>
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <React.Fragment>
      <section className="commonpad maincontent_div">
        <Container fluid>
          <h3 className="main_head">{t('dashboard.heading')}</h3>
          <Row className="g-4">
            <Col lg={3}>
              <div className="stats">
                <span className={currentLanguage === "he" ? "rtlClass statsicon" : "statsicon"}   >
                  <Icon icon="solar:calendar-linear" />
                </span>
                <div className="stats-cont">
                  <h4>{saveResult && saveResult.booking || 0}</h4>
                  <p>{t("dashboard.total_bookings")}</p>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="stats">
                <span className={currentLanguage === "he" ? "rtlClass statsicon statsblue" : "statsicon statsblue"} >
                  {" "}
                  <Icon icon="solar:eye-outline" />
                </span>
                <div className="stats-cont">
                  <h4>{saveResult && saveResult.views || 0}</h4>
                  <p>{t("dashboard.property_views")}</p>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="stats">
                <span className={currentLanguage === "he" ? "rtlClass statsicon statsblue" : "statsicon statsblue"}  >
                  <Icon icon="material-symbols:star-outline" />
                </span>
                <div className="stats-cont">
                  <h4>{saveResult && saveResult.review || 0}</h4>
                  <p>{t("dashboard.total_reviews")}</p>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="g-4 mt-0">
            <Col lg={6}>
              <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                  <h5>{t("dashboard.bookings")}</h5>
                  <Form.Select
                    className={currentLanguage === "he" ? "rtl-dropdown maxwidth120" : "ltr-dropdown maxwidth120"}
                    value={selected}
                    onChange={handleOptionChangeBooking}
                  >
                    <option value="1">{t("dashboard.weekly")}</option>
                    <option value="2">{t("dashboard.monthly")}</option>
                    <option value="3">{t("dashboard.yearly")}</option>
                  </Form.Select>
                </Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <AreaChart
                      data={bookingChat}
                      margin={{
                        top: 20,
                        right: 0,
                        left: -20,
                        bottom: 0,
                      }}
                    >
                      {" "}
                      <defs>
                        <linearGradient
                          id="areaGradient"
                          x1="0"
                          y1="1"
                          x2="0"
                          y2="0"
                        >
                          <stop
                            offset="5%"
                            stopColor={gradientColors[0]}
                            stopOpacity={0.1}
                          />
                          <stop
                            offset="95%"
                            stopColor={gradientColors[1]}
                            stopOpacity={0.7}
                          />
                        </linearGradient>
                      </defs>
                      <CartesianGrid stroke="#EAEAEA" strokeWidth={1} />
                      <XAxis
                        dataKey="name"
                        stroke="none"
                        tick={{ fill: "black", fontSize: 10 }}
                      />
                      <YAxis
                        tickFormatter={formatYAxisTick}
                        stroke="none"
                        tick={{ fill: "black", fontSize: 10 }}
                      />
                      <Tooltip content={<CustomTooltip />} />
                      <Area
                        type="monotone"
                        dataKey="Value"
                        stroke="#1B91BF " // Dark curve line color
                        fill="url(#areaGradient)"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6}>
              <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                  <h5>{t("dashboard.property_views_chart")}</h5>
                  <Form.Select
                    className={currentLanguage === "he" ? "rtl-dropdown maxwidth120" : "ltr-dropdown maxwidth120"}
                    value={selectedOption}
                    onChange={handleOptionChange}
                  >
                    <option value="1">{t("dashboard.weekly")}</option>
                    <option value="2">{t("dashboard.monthly")}</option>
                    <option value="3">{t("dashboard.yearly")}</option>
                  </Form.Select>
                </Card.Header>
                <Card.Body>
                  <ResponsiveContainer width="100%" height={300}>
                    <AreaChart
                      data={bookingChatVeiw}
                      margin={{
                        top: 20,
                        right: 0,
                        left: -10,
                        bottom: 0,
                      }}
                    >
                      <CartesianGrid stroke="#EAEAEA" strokeWidth={1} />
                      <XAxis
                        dataKey="name"
                        stroke="none"
                        tick={{ fill: "black", fontSize: 10 }}
                      />
                      <YAxis
                        tickFormatter={formatYAxisTick2}
                        stroke="none"
                        tick={{ fill: "black", fontSize: 10 }}
                      />
                      <Tooltip content={<CustomTooltip2 />} />
                      <Area
                        type="monotone"
                        dataKey="Value"
                        stroke="#1B91BF"
                        fill="#1B91BF"
                        fillOpacity={1}
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="g-4 mt-0">
            <Col md={12}>
              {isDataLoading ? (
                <div className="text-center d-flex justify-content-center">
                  <LoaderHome />
                </div>
              ) : (
                <DataTable
                  columns={columns1}
                  data={propertyData}
                  pagination
                  noHeader
                  responsive
                  paginationComponentOptions={paginationOptions}
                  className="tableDataTable"
                />
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
};
export default PropertydashboardScreen;
